import { createAction } from '@reduxjs/toolkit';

/**
 * @param {string} room
 * @returns {{ type: 'server/subscribe', room: string }}
 */
export const subscribe = (
  room: string,
): { type: 'server/subscribe'; room: string } => {
  return { type: 'server/subscribe', room };
};

/**
 * @param {string} room
 * @returns {{ type: 'server/unsubscribe', room: string }}
 */
export const unsubscribe = (
  room: string,
): { type: 'server/unsubscribe'; room: string } => {
  return { type: 'server/unsubscribe', room };
};

export const resetUnreadTexts = createAction('server/resetUnreadTexts');
